<template>
  <div class="profile-account">

    <!-- =====================================================
         ACCOUNT ACCESS
    ====================================================== -->

    <section class="account-card">

      <div class="account-card-glow"></div>

      <div class="account-card-header">

        <div class="header-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M8.5 11V8.5C8.5 6.57 10.07 5 12 5C13.93 5 15.5 6.57 15.5 8.5V11"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />

            <rect
              x="6"
              y="11"
              width="12"
              height="9"
              rx="2.5"
              stroke="currentColor"
              stroke-width="1.7"
            />

            <circle
              cx="12"
              cy="15.5"
              r="1.1"
              fill="currentColor"
            />
          </svg>
        </div>


        <div class="header-copy">

          <div class="eyebrow">
            Безопасность
          </div>

          <h2 class="card-title">
            Ваш аккаунт
          </h2>

          <p class="card-description">
            Информация о способе входа и данные,
            связанные с вашим аккаунтом Hr3.
          </p>

        </div>

      </div>


      <!-- =====================================================
           LOGIN INFO
      ====================================================== -->

      <div class="login-info-grid">

        <div class="login-info-item">

          <div class="login-item-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M8 11L11 14L16 9"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <circle
                cx="12"
                cy="12"
                r="8"
                stroke="currentColor"
                stroke-width="1.7"
              />
            </svg>
          </div>


          <div class="login-item-copy">

            <span class="login-info-label">
              Способ входа
            </span>

            <span class="login-info-value">
              {{ providerLabel }}
            </span>

          </div>

        </div>


        <div class="login-info-item">

          <div class="login-item-icon">
            <svg
              v-if="provider === 1"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M7.5 4.5L9.7 8.3L8.1 9.8C9.1 12.2 10.8 13.9 13.2 14.9L14.7 13.3L18.5 15.5C19 15.8 19.2 16.4 19 16.9C18.2 18.7 16.4 19.6 14.5 19.1C9.7 17.9 6.1 14.3 4.9 9.5C4.4 7.6 5.3 5.8 7.1 5C7.6 4.8 7.2 4.3 7.5 4.5Z"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              v-else
              viewBox="0 0 24 24"
              fill="none"
            >
              <rect
                x="4"
                y="6"
                width="16"
                height="12"
                rx="2.5"
                stroke="currentColor"
                stroke-width="1.7"
              />

              <path
                d="M5 8L12 13L19 8"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>


          <div class="login-item-copy">

            <span class="login-info-label">
              {{ provider === 1 ? "Телефон" : "Аккаунт" }}
            </span>

            <span
              class="login-info-value login-info-account"
              :title="accountValue"
            >
              {{ accountValue }}
            </span>

          </div>

        </div>

      </div>

    </section>


    <!-- =====================================================
         ACCOUNT ACTIONS
    ====================================================== -->

    <section class="actions-card">

      <div class="section-heading">

        <div>
          <div class="section-eyebrow">
            Управление
          </div>

          <h3>
            Настройки аккаунта
          </h3>
        </div>

      </div>


      <div class="actions-list">

        <!-- SUPPORT -->

        <button
          type="button"
          class="account-action"
          @click="$emit('contact-support')"
        >

          <div class="action-icon">
            <img
              :src="supportIcon"
              alt=""
            />
          </div>


          <div class="text-content">

            <div class="main-text">
              Написать в поддержку
            </div>

            <div class="sub-text">
              Сообщите нам об ошибке или задайте вопрос
            </div>

          </div>


          <div class="action-arrow">
            <svg
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7 5L12 10L7 15"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

        </button>


        <div class="action-divider"></div>


        <!-- FREEZE -->

        <button
          type="button"
          class="account-action"
          @click="$emit('freeze-account')"
        >

          <div class="action-icon">
            <img
              :src="freezeIcon"
              alt=""
            />
          </div>


          <div class="text-content">

            <div class="main-text">
              Заморозить аккаунт
            </div>

            <div class="sub-text">
              Временно скрыть профиль, сохранив все ваши данные
            </div>

          </div>


          <div class="action-arrow">
            <svg
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7 5L12 10L7 15"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

        </button>


        <div class="action-divider"></div>


        <!-- LOGOUT -->

        <button
          type="button"
          class="account-action"
          @click="$emit('logout')"
        >

          <div class="action-icon">
            <img
              :src="logoutIcon"
              alt=""
            />
          </div>


          <div class="text-content">

            <div class="main-text">
              Выйти из аккаунта
            </div>

            <div class="sub-text">
              Завершить текущую сессию на этом устройстве
            </div>

          </div>


          <div class="action-arrow">
            <svg
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7 5L12 10L7 15"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

        </button>

      </div>

    </section>


    <!-- =====================================================
         DANGER ZONE
    ====================================================== -->

    <section class="danger-card">

      <div class="danger-header">

        <div class="danger-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 8V13"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />

            <circle
              cx="12"
              cy="16.5"
              r="1"
              fill="currentColor"
            />

            <path
              d="M10.2 4.9L3.7 17C3.1 18.1 3.9 19.5 5.2 19.5H18.8C20.1 19.5 20.9 18.1 20.3 17L13.8 4.9C13.1 3.7 10.9 3.7 10.2 4.9Z"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linejoin="round"
            />
          </svg>
        </div>


        <div>

          <div class="danger-eyebrow">
            Удаление
          </div>

          <h3>
            Удаление аккаунта
          </h3>

          <p>
            После удаления аккаунта восстановить профиль
            и связанные с ним данные будет невозможно.
          </p>

        </div>

      </div>


      <div class="danger-footer">

        <div
          v-if="userId"
          class="user-id"
        >
          <span>
            ID пользователя
          </span>

          <strong>
            {{ userId }}
          </strong>
        </div>


        <button
          type="button"
          class="delete-button"
          @click="$emit('delete-account')"
        >
          <img
            :src="deleteIcon"
            alt=""
          />

          Удалить аккаунт
        </button>

      </div>

    </section>

  </div>
</template>


<script setup>

import {
  computed
} from "vue";

import supportIcon
  from "../../assets/support-profile.png";

import freezeIcon
  from "../../assets/freeze-profile.png";

import logoutIcon
  from "../../assets/logout-profile.png";

import deleteIcon
  from "../../assets/delete-profile.png";


const props = defineProps({

  userId: {
    type: String,
    required: false
  },

  provider: {
    type: Number,
    required: false,
    default: null
  },

  authEmail: {
    type: String,
    required: false,
    default: ""
  },

  phoneNumber: {
    type: String,
    required: false,
    default: ""
  }

});


defineEmits([
  "contact-support",
  "freeze-account",
  "logout",
  "delete-account"
]);


/* ============================================================
   PROVIDER
============================================================ */

const providerLabel = computed(() => {

  const providers = {
    1: "Телефон",
    3: "Apple",
    4: "Google",
    5: "Email"
  };

  return (
    providers[props.provider]
    || "Не определён"
  );

});


/* ============================================================
   ACCOUNT VALUE
============================================================ */

const accountValue = computed(() => {

  if (props.provider === 1) {

    return (
      props.phoneNumber
      || "Номер не указан"
    );

  }


  return (
    props.authEmail
    || "Email не указан"
  );

});

</script>


<style scoped>

/* ============================================================
   ROOT
============================================================ */

.profile-account {
  width: 100%;

  display: flex;
  flex-direction: column;

  gap: 16px;

  font-family:
    "Eastman-Regular",
    sans-serif;
}


/* ============================================================
   BASE CARD
============================================================ */

.account-card,
.actions-card,
.danger-card {
  position: relative;

  width: 100%;

  box-sizing: border-box;

  overflow: hidden;

  background: #ffffff;

  border:
    1px solid
    rgba(
      20,
      35,
      60,
      0.09
    );

  border-radius: 24px;

  box-shadow:
    0 16px 45px
    rgba(
      15,
      23,
      42,
      0.055
    );
}


/* ============================================================
   ACCOUNT CARD
============================================================ */

.account-card {
  padding: 28px;
}


.account-card-glow {
  position: absolute;

  top: -130px;
  right: -90px;

  width: 280px;
  height: 280px;

  pointer-events: none;

  background:
    #2887f7;

  border-radius: 50%;

  filter:
    blur(90px);

  opacity: 0.1;
}


.account-card-header {
  position: relative;

  z-index: 2;

  display: flex;
  align-items: flex-start;

  gap: 15px;
}


.header-icon {
  width: 48px;
  height: 48px;

  flex:
    0
    0
    48px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #3b7fe7;

  background:
    linear-gradient(
      145deg,
      rgba(40, 135, 247, 0.12),
      rgba(124, 92, 231, 0.07)
    );

  border:
    1px solid
    rgba(
      40,
      120,
      230,
      0.11
    );

  border-radius: 15px;
}


.header-icon svg {
  width: 23px;
  height: 23px;
}


.header-copy {
  min-width: 0;
}


.eyebrow,
.section-eyebrow,
.danger-eyebrow {
  margin-bottom: 5px;

  color: #9499a2;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 9px;

  line-height: 1.2;

  letter-spacing: 0.07em;

  text-transform: uppercase;
}


.card-title {
  margin: 0;

  color: #292e35;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size: 17px;

  line-height: 1.3;

  letter-spacing: -0.25px;
}


.card-description {
  max-width: 520px;

  margin:
    6px
    0
    0;

  color: #80858e;

  font-size: 11px;

  line-height: 1.5;
}


/* ============================================================
   LOGIN GRID
============================================================ */

.login-info-grid {
  position: relative;

  z-index: 2;

  display: grid;

  grid-template-columns:
    repeat(
      2,
      minmax(0, 1fr)
    );

  gap: 10px;

  margin-top: 25px;
}


.login-info-item {
  min-width: 0;

  display: flex;
  align-items: center;

  gap: 11px;

  padding: 14px;

  background:
    rgba(
      247,
      249,
      252,
      0.88
    );

  border:
    1px solid
    rgba(
      25,
      40,
      60,
      0.065
    );

  border-radius: 15px;
}


.login-item-icon {
  width: 34px;
  height: 34px;

  flex:
    0
    0
    34px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #4c7bd7;

  background:
    rgba(
      48,
      112,
      224,
      0.075
    );

  border-radius: 10px;
}


.login-item-icon svg {
  width: 17px;
  height: 17px;
}


.login-item-copy {
  min-width: 0;

  display: flex;
  flex-direction: column;

  gap: 3px;
}


.login-info-label {
  color: #969ba3;

  font-size: 8px;

  letter-spacing: 0.04em;

  text-transform: uppercase;
}


.login-info-value {
  max-width: 100%;

  overflow: hidden;

  color: #343940;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 11px;

  line-height: 1.35;

  text-overflow: ellipsis;

  white-space: nowrap;
}


/* ============================================================
   ACTIONS CARD
============================================================ */

.actions-card {
  padding:
    25px
    20px
    12px;
}


.section-heading {
  padding:
    0
    8px
    15px;
}


.section-heading h3 {
  margin: 0;

  color: #30353d;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 14px;

  font-weight: 500;
}


.actions-list {
  display: flex;
  flex-direction: column;
}


.account-action {
  width: 100%;

  display: grid;

  grid-template-columns:
    40px
    minmax(0, 1fr)
    30px;

  align-items: center;

  gap: 12px;

  min-height: 72px;

  padding:
    10px
    10px;

  appearance: none;
  -webkit-appearance: none;

  text-align: left;

  background: transparent;

  border: none;
  border-radius: 14px;

  cursor: pointer;

  transition:
    background-color
    0.2s ease,
    transform
    0.2s ease;
}


.account-action:hover {
  background:
    rgba(
      40,
      135,
      247,
      0.055
    );

  transform:
    translateX(2px);
}


.action-icon {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  background:
    #f4f7fb;

  border:
    1px solid
    rgba(
      30,
      45,
      65,
      0.06
    );

  border-radius: 12px;
}


.action-icon img {
  width: 19px;
  height: 19px;

  display: block;

  object-fit: contain;
}


.text-content {
  min-width: 0;
}


.main-text {
  color: #383d45;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 11px;

  line-height: 1.3;
}


.sub-text {
  max-width: 520px;

  margin-top: 4px;

  color: #969ba4;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size: 9px;

  line-height: 1.4;
}


.action-arrow {
  width: 29px;
  height: 29px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #9da2ab;

  border-radius: 9px;

  transition:
    color
    0.2s ease,
    background-color
    0.2s ease,
    transform
    0.2s ease;
}


.action-arrow svg {
  width: 16px;
  height: 16px;
}


.account-action:hover
.action-arrow {
  color: #337ce2;

  background:
    rgba(
      40,
      135,
      247,
      0.08
    );

  transform:
    translateX(2px);
}


.action-divider {
  height: 1px;

  margin-left: 62px;

  background:
    rgba(
      25,
      40,
      60,
      0.065
    );
}


/* ============================================================
   DANGER
============================================================ */

.danger-card {
  padding: 24px;

  background:
    linear-gradient(
      145deg,
      rgba(255, 255, 255, 1),
      rgba(255, 249, 249, 0.95)
    );

  border-color:
    rgba(
      215,
      55,
      55,
      0.11
    );
}


.danger-header {
  display: flex;
  align-items: flex-start;

  gap: 13px;
}


.danger-icon {
  width: 42px;
  height: 42px;

  flex:
    0
    0
    42px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #da5555;

  background:
    rgba(
      220,
      65,
      65,
      0.07
    );

  border:
    1px solid
    rgba(
      220,
      65,
      65,
      0.09
    );

  border-radius: 13px;
}


.danger-icon svg {
  width: 20px;
  height: 20px;
}


.danger-eyebrow {
  color: #c98585;
}


.danger-header h3 {
  margin: 0;

  color: #473536;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 13px;

  font-weight: 500;
}


.danger-header p {
  max-width: 520px;

  margin:
    5px
    0
    0;

  color: #9a8587;

  font-size: 9px;

  line-height: 1.45;
}


.danger-footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  gap: 20px;

  margin-top: 23px;

  padding-top: 18px;

  border-top:
    1px solid
    rgba(
      215,
      55,
      55,
      0.09
    );
}


.user-id {
  min-width: 0;

  display: flex;
  flex-direction: column;

  gap: 3px;
}


.user-id span {
  color: #aaa0a1;

  font-size: 8px;

  text-transform: uppercase;

  letter-spacing: 0.05em;
}


.user-id strong {
  max-width: 390px;

  overflow: hidden;

  color: #777074;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size: 9px;

  font-weight: 400;

  text-overflow: ellipsis;

  white-space: nowrap;
}


.delete-button {
  min-height: 38px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 7px;

  padding:
    0
    14px;

  flex-shrink: 0;

  color: #d54f4f;

  background:
    rgba(
      213,
      70,
      70,
      0.065
    );

  border:
    1px solid
    rgba(
      213,
      70,
      70,
      0.11
    );

  border-radius: 11px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 10px;

  cursor: pointer;

  transition:
    background-color
    0.2s ease,
    border-color
    0.2s ease,
    transform
    0.2s ease;
}


.delete-button img {
  width: 15px;
  height: 15px;

  object-fit: contain;
}


.delete-button:hover {
  background:
    rgba(
      213,
      70,
      70,
      0.105
    );

  border-color:
    rgba(
      213,
      70,
      70,
      0.18
    );

  transform:
    translateY(-1px);
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.account-card,
html[data-theme="dark"]
.actions-card {
  background:
    linear-gradient(
      145deg,
      #22242a,
      #1d1f24
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );

  box-shadow:
    0 18px 50px
    rgba(
      0,
      0,
      0,
      0.24
    );
}


html[data-theme="dark"]
.card-title,
html[data-theme="dark"]
.section-heading h3 {
  color: #f1f2f4;
}


html[data-theme="dark"]
.card-description {
  color: #9499a2;
}


html[data-theme="dark"]
.login-info-item {
  background:
    rgba(
      255,
      255,
      255,
      0.035
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.06
    );
}


html[data-theme="dark"]
.login-info-value {
  color: #e4e6e9;
}


html[data-theme="dark"]
.action-icon {
  background:
    rgba(
      255,
      255,
      255,
      0.045
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.055
    );
}


html[data-theme="dark"]
.main-text {
  color: #e3e5e8;
}


html[data-theme="dark"]
.sub-text {
  color: #858a93;
}


html[data-theme="dark"]
.account-action:hover {
  background:
    rgba(
      255,
      255,
      255,
      0.04
    );
}


html[data-theme="dark"]
.action-divider {
  background:
    rgba(
      255,
      255,
      255,
      0.06
    );
}


html[data-theme="dark"]
.danger-card {
  background:
    linear-gradient(
      145deg,
      #242124,
      #201d20
    );

  border-color:
    rgba(
      235,
      90,
      90,
      0.11
    );

  box-shadow:
    0 18px 50px
    rgba(
      0,
      0,
      0,
      0.22
    );
}


html[data-theme="dark"]
.danger-header h3 {
  color: #f0dddd;
}


html[data-theme="dark"]
.danger-header p {
  color: #a68f91;
}


html[data-theme="dark"]
.user-id strong {
  color: #aa9c9f;
}


/* ============================================================
   MOBILE
============================================================ */

@media (max-width: 700px) {

  .profile-account {
    gap: 13px;
  }


  .account-card,
  .danger-card {
    padding: 20px;

    border-radius: 20px;
  }


  .actions-card {
    padding:
      21px
      12px
      10px;

    border-radius: 20px;
  }


  .login-info-grid {
    grid-template-columns: 1fr;
  }


  .account-action {
    grid-template-columns:
      38px
      minmax(0, 1fr)
      28px;

    min-height: 68px;
  }


  .action-icon {
    width: 38px;
    height: 38px;
  }


  .danger-footer {
    align-items: stretch;
    flex-direction: column;
  }


  .user-id strong {
    max-width: 100%;
  }


  .delete-button {
    width: 100%;

    min-height: 42px;
  }

}


/* ============================================================
   REDUCED MOTION
============================================================ */

@media (prefers-reduced-motion: reduce) {

  .account-action,
  .action-arrow,
  .delete-button {
    transition: none;
  }

}

</style>